import angular from 'angular';
import uiRouter from 'angular-ui-router';
import FillSubCaseComponent from './fillSubCase.component';
import routing from './fillSubCase.routes';

export default angular
  .module('verifyApp.public.cases.publicFillSubCase', [uiRouter])
  .config(routing)
  .component('publicFillSubCase', FillSubCaseComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/public/case/fillSubCase/index.js